import script from "./copyrightBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./copyrightBlock.vue?vue&type=script&setup=true&lang=ts"

import "./copyrightBlock.vue?vue&type=style&index=0&id=1fc4c794&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc4c794"]])

export default __exports__